type Constructor<T = {}> = new (...args: any[]) => T;

export function Selectable<TBase extends Constructor>(Base: TBase) {
  return class extends Base {
    selected: boolean = false;

    constructor(...args: any[]) {
      super(...args);
    }

    toggleSelect() {
      this.selected = !this.selected;
    }
  };
}

export class SelectablePrimitive<T extends string | boolean | number> {
  selected: boolean = false;
  value: T;

  constructor(value: T, selected?: boolean) {
    this.value = value;
    this.selected = selected || false;
  }

  toggleSelect() {
    this.selected = !this.selected;
  }
}

export class SelectableOption<T> {
  selected: boolean = false;
  value: T;
  label: string;

  constructor(value: T, label: string, selected?: boolean) {
    this.value = value;
    this.label = label;
    this.selected = selected || false;
  }

  toggleSelect() {
    this.selected = !this.selected;
  }
}
